import {Button} from "../../../basic/button.tsx";
import {Card} from "../../../basic/card.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface QuickLink {
    title: string;
    description: string;
    icon: React.ComponentType<{ className?: string }>;
    action: () => void;
}

interface QuickLinksProps {
    quickLinks: QuickLink[];
}

export function QuickLinks({quickLinks}: QuickLinksProps) {
    const {t} = useTranslationWithKeys();

    return (
        <Card className="p-6 shadow-sm border-border/50">
            <h3 className="mb-4">{t('support.quickLinks')}</h3>
            <div className="grid gap-3">
                {quickLinks.map((link, index) => {
                    const Icon = link.icon;
                    return (
                        <Button
                            key={index}
                            variant="outline"
                            onClick={link.action}
                            className="flex items-center gap-3 p-3 h-auto justify-start text-left"
                        >
                            <Icon className="h-5 w-5 text-muted-foreground flex-shrink-0"/>
                            <div className="flex-1 min-w-0">
                                <p className="mb-0.5">{link.title}</p>
                                <p className="text-muted-foreground truncate">{link.description}</p>
                            </div>
                        </Button>
                    );
                })}
            </div>
        </Card>
    );
}